module.exports = __webpack_public_path__ + "static/media/profileActive.c9264621.svg";